import { render, staticRenderFns } from "./TextType.vue?vue&type=template&id=108c1b96&scoped=true"
import script from "./TextType.vue?vue&type=script&lang=ts"
export * from "./TextType.vue?vue&type=script&lang=ts"
import style0 from "./TextType.vue?vue&type=style&index=0&id=108c1b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c1b96",
  null
  
)

export default component.exports